import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient,
  ) { }

  async post(api: string, params: any): Promise<any> {
    console.log('HttpService POST - URL:', api);
    console.log('HttpService POST - Params:', params);
    return await new Promise((resolve, reject) => {
      this.http.post(api, params, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }).subscribe({
        next: (data) => {
          console.log('HttpService POST - Response:', data);
          resolve(data);
        },
        error: (err) => {
          console.error('HttpService POST - Error:', err);
          console.error('HttpService POST - Error Details:', {
            status: err.status,
            statusText: err.statusText,
            message: err.message,
            error: err.error,
            url: api
          });
          
          // Si es un error de CORS, dar un mensaje más claro
          if (err.status === 0 || err.status === null) {
            console.error('Posible error de CORS - La solicitud fue bloqueada por el navegador');
            console.error('Verifica que el endpoint tenga CORS configurado correctamente');
          }
          
          reject(err);
        }
      });
    });
  }

  async get(api: string, params?: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      this.http.get(api, params).subscribe({
        next: (data) => resolve(data),
        error: (err) => reject(err)
      });
    });
  }


}

